import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
  } from "../../config/axiosInstance";
  
export const activityListApi = async (data) => {
  const endPoint = `admin/activity/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
  
export const activityDetailApi = async (data) => {
  const endPoint = `admin/activity?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};

export const addActivityApi = async (data) => {
    const endPoint = `admin/activity`;
    return await axios.post(endPoint, data, setMultiPartHeader());
};

export const updateActivityApi = async (data) => {
    const endPoint = `admin/activity`;
    return await axios.put(endPoint, data, setMultiPartHeader());
};

export const deleteActivityApi = async (data) => {
  const endPoint = `admin/activity?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.delete(endPoint, setJwtToken());
};